module.exports = __webpack_public_path__ + "static/media/change_fuel.e778fd8e.svg";